/**
 * Handle authentication requests and session management
 */
angular
  .module('acme.common.service.auth', [
    'acme.common.service.api',
    'acme.common.service.permissions',
    'acme.common.service.featureToggle',
  ])
  .service('AuthService', [
    '$window',
    '$http',
    'ApiService',
    'PermissionsService',
    'FeatureToggleService',
    function ($window, $http, ApiService, PermissionsService, FeatureToggleService) {
      return {
        roles: [],
        CSRF: null,

        encodedCookies: ['csr', 'user'],

        /**
         * Logs user in via ApiService
         * @param {{ email: string; password: string }} props
         * @returns {Promise}
         */
        login: function (props) {
          return ApiService.user.login(props);
        },

        /**
         * Verify a user account
         *
         * Accepts:
         * {
         *   token: {String}
         * }
         *
         * @param props
         * @returns {*}
         */
        confirm: function (props) {
          return ApiService.user.confirm({
            token: props.token,
          });
        },

        /**
         * Logs a user out via ApiService
         *
         * @returns {*}
         */
        logout: function () {
          return ApiService.user.logout();
        },

        /**
         * Convenience method
         * Sends a request to verify hostname
         *
         * @param hostname { string }
         */
        preFlightCheck: function (hostname) {
          return ApiService.system.preFlightCheck({ hostName: hostname });
        },

        /**
         * Wrapper for Cookies.get(...)
         *
         * @param name
         * @returns {Object}
         */
        getCookie: function (name) {
          var cookie = $window.Cookies.get(name);

          if (this.encodedCookies.includes(name) && cookie) {
            try {
              cookie = atob(cookie);
            } catch (e) {}
          }

          if (cookie && cookie.match(/^\{/)) {
            cookie = angular.fromJson(cookie);
          }

          return cookie;
        },

        setCSRF: function (csrf) {
          this.CSRF = csrf;
        },

        getCSRF: function (key) {
          var r = null;

          if (key && this.CSRF.hasOwnProperty(key)) {
            r = this.CSRF[key];
          } else {
            r = this.CSRF;
          }

          return r;
        },

        updateCSRF: function () {
          var self = this;

          /**
           * Set X/CSRF token
           */
          ApiService.system.csrf().then(
            function (response) {
              self.setCSRF(response.data.payload);
              $http.defaults.headers.common[$http.defaults.xsrfHeaderName] = self.getCSRF('token');
              $http.defaults.headers.post[$http.defaults.xsrfHeaderName] = self.getCSRF('token');
              $http.defaults.headers.put[$http.defaults.xsrfHeaderName] = self.getCSRF('token');
            },
            function (response) {
              // TODO: Something happened with the call need to handle
            }
          );
        },

        /**
         * Verify value passed is contained in roles
         *
         * @param roles {String|Array}
         * @returns {boolean}
         */
        hasRole: function (roles) {
          var i,
            ii,
            r = false;

          this.getRoles();
          if (roles instanceof Array) {
            console.log('hasRole');
            for (i = 0, ii = roles.length; i < ii; i++) {
              if (this.roles.indexOf(roles[i]) >= 0) {
                r = true;
                break;
              }
            }
          } else if (typeof roles === 'string') {
            console.log(roles, this.roles, this.roles.indexOf(roles));
            r = this.roles.indexOf(roles) >= 0;
          }

          return r;
        },

        /**
         * Gets current users' roles
         *
         * @returns {Array}
         */
        getRoles: function () {
          var i,
            ii,
            r = [],
            splitRoles = [],
            user = this.getCookie('user'),
            roles = user ? user.roles : false;

          if (roles) {
            if (typeof roles === 'string') {
              if (roles.indexOf(',') === -1) {
                splitRoles.push(roles);
              } else {
                splitRoles = roles.split(',');
              }
            } else if (roles instanceof Array) {
              splitRoles = roles;
            }

            if (splitRoles.length > 0) {
              // Remove whitespace from roles
              for (i = 0, ii = splitRoles.length; i < ii; i++) {
                r.push(splitRoles[i].replace(/\s+/g, ''));
              }
            } else {
              r = ['user'];
            }
          }

          return (this.roles = r);
        },

        setPermissions: function (permissions) {
          return PermissionsService.store(permissions);
        },

        hasPermission: function (permissions) {
          return PermissionsService.check(permissions);
        },

        getPermissions: function () {
          return PermissionsService.fetch();
        },

        getFeatures: function () {
          return FeatureToggleService.fetch();
        },

        hasPermissions: function () {
          return PermissionsService.hasPermissions();
        },

        testChecksum: function (checksum) {
          var currentChecksum = PermissionsService.fetchMD5();
          return checksum === currentChecksum;
        },

        /**
         * Wrapper for Cookies.set(...);
         *
         * @param name
         * @param value
         */
        setCookie: function (name, value) {
          $window.Cookies.set(name, angular.toJson(value));
        },

        /**
         * Wrapper for $.removeCookie(...);
         *
         * @param name
         */
        killCookie: function (name) {
          // Using JQuery
          return $window.Cookies.remove(name);
        },

        killStorage: function () {
          PermissionsService.clearAll();
        },

        destroy: function () {
          this.killCookie('session');
          this.killCookie('user');
          this.killCookie('utc');
          this.killStorage();
        },

        getLoggedInPaths: function () {
          var path = false;

          this.getPermissions();
          // Default landing state for onboarded users who are admin or non-personnel
          path = {
            state: 'application.programs.list',
            url: '/app/programs/list',
          };

          return path;
        },

        getHomeUrl: function () {
          var url = '',
            session = this.getCookie('session'),
            path;

          if (session) {
            path = this.getLoggedInPaths();
            if (path !== false) {
              url = path.url;
            }
          } else {
            // User is not logged in head login page
            url = '/login';
          }

          return url;
        },

        getRedirectState: function () {
          var path,
            state = false,
            user = this.getCookie('user');

          if (user && user.hasOwnProperty('confirmed')) {
            // User is confirmed via email
            if (user.confirmed) {
              // User has completed registration
              if (user.hasOwnProperty('onBoarded') && user.onBoarded) {
                path = this.getLoggedInPaths();
                if (path !== false) {
                  state = path.state;
                }
              } else {
                state = 'onboard.default';
              }
            } else {
              state = 'onboard.default';
            }
          }

          return state;
        },
      };
    },
  ]);
